'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitLiveBid = exports.getBidderHasHighBid = exports.getUiLiveBid = exports.LIVE_BID_SUCCESS = exports.LIVE_BID_REQUEST = exports.LIVE_BID_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _console = require('./console');

var _reselect = require('reselect');

var _liveCatalogStatus = require('./liveCatalogStatus');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LIVE_BID_FAIL = exports.LIVE_BID_FAIL = 'la/ui/liveBid/FAIL';
var LIVE_BID_REQUEST = exports.LIVE_BID_REQUEST = 'la/ui/liveBid/REQUEST';
var LIVE_BID_SUCCESS = exports.LIVE_BID_SUCCESS = 'la/ui/liveBid/SUCCESS';

// reducer
var DEFAULT_STATE = {
    bidderHasHighBid: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LIVE_BID_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case _console.BID_ACCEPTED:
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: action.payload.myBid,
                submitted: false,
                success: true
            });
        case _console.LOT_CLOSED:
        case _console.LOT_PASSED:
        case _console.LOT_SKIPPED:
        case _console.LOT_SOLD:
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: false,
                submitted: false,
                success: true
            });
        case LIVE_BID_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case LIVE_BID_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case _console.NEXT_LOT_LOADED:
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: false,
                submitted: false
            });
        case _liveCatalogStatus.LOAD_LIVE_CATALOG_STATUS_SUCCESS:
            var currentHighBidderId = action.payload.currentItem.leadingBidder;
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: action.meta.bidderId === currentHighBidderId
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.liveBid;
};
var getUiLiveBid = exports.getUiLiveBid = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getBidderHasHighBid = exports.getBidderHasHighBid = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.bidderHasHighBid;
});

/* ACTIONS CREATORS */
var submitLiveBid = exports.submitLiveBid = function submitLiveBid(catalogId, amount, currency) {
    return function (dispatch) {
        try {
            dispatch({
                payload: {
                    amount: amount,
                    catalogId: catalogId,
                    currency: currency
                },
                type: LIVE_BID_REQUEST
            });
        } catch (error) {
            dispatch({
                error: true,
                payload: error,
                type: LIVE_BID_FAIL
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/liveBid.js
// module id = xmqD
// module chunks = 57